import { Status } from "consts/users";
import { convertArrayToString } from "util/transformers";
import type { Role, Roles, User, Users } from "./types";

export const decorateRoleOptions = (roles: Roles = []) =>
    roles.map(({ coreId, roleName, roleDescription, displayName }: Role) => ({
        id: coreId,
        name: convertArrayToString([roleName, roleDescription], ' - '),
        displayName: displayName,
    })) ?? [];

export const decorateUsersOptions = (users: Users = []) =>
    users.map(({ coreId, firstName, lastName }: User) => ({
        id: coreId,
        name: `${convertArrayToString([firstName, lastName], ' - ')} (${coreId})`
    })) ?? [];

export const selectActiveUsers = (users: Users) => users.filter(({ status }) =>
    [Status.Active].includes(status as Status)
);

export const selectInactiveUsers = (users: Users) => users.filter(({ status }) =>
    ![Status.Active].includes(status as Status)
);
